import { ShieldCheckIcon } from '@heroicons/react/24/solid';
import { Card, CardBody, CardHeader } from '@heroui/react';
import { Description, Label } from '@/primitives/fieldset.tsx';
import { Switch, SwitchField } from '@/primitives/switch.tsx';
import type { AccountModel } from '../../../types/account.type.ts';

type Props = {
  account: AccountModel;
  putAccount: (account: AccountModel) => void;
};

export default function AccountSettingsPermissions({ account, putAccount }: Props) {
  const handleUserChatChange = (value: boolean) => {
    const model = {
      ...account,
      restrictUserExternalChat: value,
    } as AccountModel;
    putAccount(model);
  };

  const handleManagerChatChange = (value: boolean) => {
    const model = {
      ...account,
      restrictManagerExternalChat: value,
    } as AccountModel;
    putAccount(model);
  };

  return (
    <Card>
      <CardHeader className='flex gap-2 items-center px-4 pt-4'>
        <ShieldCheckIcon className='size-5' aria-hidden='true' />
        <h2 className='font-semibold'>Permissions</h2>
      </CardHeader>
      <CardBody className='px-4 pb-4'>
        <div className='flex flex-col gap-4'>
          <div>
            <SwitchField>
              <Label>Restrict User External Chat</Label>
              <Description>
                Restrict Users from sending and receiving chat from external users. i.e.
                Representatives (Default setting is yes)
              </Description>
              <Switch
                color='blue'
                checked={account?.restrictUserExternalChat ?? false}
                onChange={handleUserChatChange}
              />
            </SwitchField>
          </div>
          <div>
            <SwitchField>
              <Label>Restrict Managers External Chat</Label>
              <Description>
                Restrict Managers from sending and receiving chats from external users. i.e.
                Representatives (Default setting is yes)
              </Description>
              <Switch
                color='blue'
                checked={account?.restrictManagerExternalChat ?? false}
                onChange={handleManagerChatChange}
              />
            </SwitchField>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
